import { LEGAL_DOCUMENTS_TYPES, LegalDocumentType } from './model/LegalDocumentType';

export const MANDATORY_LEGAL_DOCUMENTS: LegalDocumentType[] = [
    LEGAL_DOCUMENTS_TYPES.GENERAL_TERMS_AND_CONDITIONS_OF_USE,
    LEGAL_DOCUMENTS_TYPES.GENERAL_DATA_PROTECTION_REGULATION,
];
